import { createContext, useContext, useState, useMemo } from "react";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [providers, setProviders] = useState([]);
  const [activeProvider, setActiveProvider] = useState("openai");
  const [orbSettings, setOrbSettings] = useState(null);
  const [savingOrbs, setSavingOrbs] = useState(false);
  const [costSummary, setCostSummary] = useState(null);

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({
      providers,
      setProviders,
      activeProvider,
      setActiveProvider,
      orbSettings,
      setOrbSettings,
      savingOrbs,
      setSavingOrbs,
      costSummary,
      setCostSummary,
    }),
    [providers, activeProvider, orbSettings, savingOrbs, costSummary]
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};



